import React from 'react'
import Grid from "@blocks/Grid"
import SalonSection from './components/Section'
import { useSalonContext } from '../../context'
import EmphasizedContent from '@blocks/EmphasizedContent'
import { Link } from 'react-router-dom'
import { route } from '@helpers'

export default function SalonSections() {
    const { salon } = useSalonContext()

    if (salon.state.status === "unavailable")
        return null
    
    return (
        <Grid gap="10px">
            <Grid gap="0px">
                <small>Entry</small>
                <hr />
            </Grid>
            {salon.state.nudity_restricted && (
                <EmphasizedContent padding="10px">
                    <small>Note: images that depict nudity aren't allowed. <a href={route("general:salon:conditions", salon.state.slug)} target="_blank">Conditions</a>.</small>
                </EmphasizedContent>
            )}
            <Grid>
                {salon.state.entry.map((section: Customer.Resources.PastSection | Customer.Resources.Section) => (
                    <SalonSection key={section.id} section={section} />
                ))}
            </Grid>
        </Grid>
    )
}